import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const StylingGuideModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  overflow-y: auto;

  .content {
    padding: 0 20px 32px;

    section + section {
      margin-top: 32px;
    }

    .info-list {
      margin-bottom: 8px;

      li {
        position: relative;
        font-size: 14px;
        line-height: 150%;
        padding-left: 21px;
        word-break: keep-all;
        color: #000;

        + li {
          margin-top: 4px;
        }

        &:after {
          position: absolute;
          top: 9.5px;
          left: 9.5px;
          display: block;
          content: '';
          width: 2px;
          height: 2px;
          background: #000;
          border-radius: 50%;
        }

        em {
          color: #ff4600;
        }
      }
    }

    .caption {
      font-size: 11px;
      line-height: 130%;
      color: #777;
      background: #f9f9f9;
      padding: 8px 10px;
    }

    .title {
      margin-bottom: 16px;
    }

    .guide {
      ${mixin.flex({ justify: 'flex-start', align: 'flex-start' })};
      gap: 0 10px;

      .img {
        border-radius: 4px;
        flex-shrink: 0;
      }

      .check-list {
        li {
          position: relative;
          font-size: 14px;
          line-height: 130%;
          padding-left: 22px;
          word-break: keep-all;

          svg {
            position: absolute;
            top: 4.5px;
            left: 3.5px;
          }

          + li {
            margin-top: 6px;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    max-height: none;
    max-height: calc(-${mixin.pxToVw('50')} + 100vh);
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .content {
      padding: ${mixin.pxToVw('0 20 32')};

      section + section {
        margin-top: ${mixin.pxToVw('32')};
      }

      .info-list {
        margin-bottom: ${mixin.pxToVw('8')};

        li {
          font-size: ${mixin.pxToVw('14')};
          padding-left: ${mixin.pxToVw('21')};

          + li {
            margin-top: ${mixin.pxToVw('4')};
          }

          &:after {
            top: ${mixin.pxToVw('9.5')};
            left: ${mixin.pxToVw('9.5')};
            width: ${mixin.pxToVw('2')};
            height: ${mixin.pxToVw('2')};
          }
        }
      }

      .caption {
        font-size: ${mixin.pxToVw('11')};
        padding: ${mixin.pxToVw('8 10')};
      }

      .title {
        margin-bottom: ${mixin.pxToVw('16')};
      }

      .guide {
        gap: ${mixin.pxToVw('0 10')};

        .img {
          border-radius: ${mixin.pxToVw('4')};
        }

        .check-list {
          li {
            font-size: ${mixin.pxToVw('14')};
            padding-left: ${mixin.pxToVw('22')};

            svg {
              top: ${mixin.pxToVw('4.5')};
              left: ${mixin.pxToVw('3.5')};
              width: ${mixin.pxToVw('12')};
              height: ${mixin.pxToVw('9')};
            }

            + li {
              margin-top: ${mixin.pxToVw('6')};
            }
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: none;
    height: auto;
    border-radius: 0;
    max-width: 560px;

    .modal-title {
      padding: 30px 52px 24px 32px;
      margin-bottom: 0;

      .title {
        text-align: left;
        font-size: 24px;
      }
    }

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .content {
      padding: 0 32px 28px 32px;

      .info-list {
        margin-bottom: 10px;

        li {
          font-size: 16px;
          line-height: 135%;

          + li {
            margin-top: 10px;
          }
        }
      }

      .caption {
        font-size: 14px;
        padding: 10px 20px;
      }

      .title {
        font-size: 17px;
      }

      .guide {
        .check-list {
          padding-right: 70px;

          li {
            font-size: 16px;
            line-height: 135%;

            + li {
              margin-top: 8px;
            }
          }
        }
      }
    }

    .modal-group-btn {
      border-top: 1px solid #eee;
      padding: 24px 87px;
    }
  }
`;
